/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const TagIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M17.5057 7.94324L10.0568 0.494262C9.7403 0.177794 9.31108 2.34027e-06 8.86353 0H1.6875C0.755508 0 0 0.755508 0 1.6875V8.86352C2.34027e-06 9.31107 0.177794 9.74029 0.494262 10.0568L7.94324 17.5057C8.60225 18.1647 9.67072 18.1648 10.3297 17.5057L17.5057 10.3297C18.1648 9.67071 18.1648 8.60224 17.5057 7.94324ZM16.7103 9.53423L9.53424 16.7103C9.31476 16.9297 8.95856 16.9301 8.73876 16.7103L1.28974 9.26124C1.23735 9.20913 1.19581 9.14714 1.16753 9.07887C1.13925 9.01059 1.1248 8.93739 1.125 8.86349V1.6875C1.125 1.37735 1.37735 1.125 1.6875 1.125H8.86353C9.01379 1.125 9.15504 1.1835 9.26129 1.28974L16.7103 8.73872C16.9296 8.95806 16.9296 9.31493 16.7103 9.53423ZM5.0625 4.35937C5.45021 4.35937 5.76563 4.6748 5.76563 5.0625C5.76563 5.4502 5.45021 5.76562 5.0625 5.76562C4.6748 5.76562 4.35938 5.4502 4.35938 5.0625C4.35938 4.6748 4.6748 4.35937 5.0625 4.35937ZM5.0625 3.375C4.13051 3.375 3.375 4.13051 3.375 5.0625C3.375 5.99449 4.13051 6.75 5.0625 6.75C5.9945 6.75 6.75 5.99449 6.75 5.0625C6.75 4.13051 5.9945 3.375 5.0625 3.375Z"
        fill={color}
      />
    </svg>
  );
};
